import type { IEmployee } from "@/interfaces/IEmployee.ts";
import type { JsonResponse } from "@/interfaces/JsonResponse.ts";

import httpMethods from "../../enums/HttpMethods.ts";
import Resources from "../../enums/Resources.ts";
import { DeprecatedAResourceService } from "../DeprecatedAResourceService.ts";

export interface IEmployeeResponse {
    result: string;
    msg: string;
    employee: IEmployee;
}

export interface IEmployeesResponse {
    result: string;
    msg: string;
    employees: IEmployee[];
}

export function isEmployeeResponse(response: IEmployeeResponse): response is IEmployeeResponse {
    return (response as IEmployeeResponse).employee !== undefined;
}

interface IRequestPayload {
    employee_id: number;
    tablet_id: number;
}

class EmployeesService extends DeprecatedAResourceService {
    public async getEmployees(kind?: string): Promise<IEmployeesResponse> {
        return this.getObjectData<IEmployeesResponse>(
            import.meta.env.VITE_API_BASE_URL,
            kind ? `${Resources.EMPLOYEES}?kind=${kind}` : Resources.EMPLOYEES,
            httpMethods.GET,
        );
    }

    public async signInOnDevice(employeeId: number, tabletId: number): Promise<IEmployeeResponse> {
        const requestBody: IRequestPayload = {
            employee_id: employeeId,
            tablet_id: tabletId,
        };
        return this.sentData<IEmployeeResponse>(
            import.meta.env.VITE_API_BASE_URL,
            `${Resources.EMPLOYEES}/sign_in_on_device`,
            httpMethods.POST,
            requestBody,
        );
    }

    public async signOutFromDevice(employeeId: number, tabletId: number): Promise<JsonResponse> {
        const requestBody: IRequestPayload = {
            employee_id: employeeId,
            tablet_id: tabletId,
        };
        return this.sentData(
            import.meta.env.VITE_API_BASE_URL,
            `${Resources.EMPLOYEES}/sign_out_from_device`,
            httpMethods.POST,
            requestBody,
        );
    }
}

export default new EmployeesService();
